// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dLJzyp73Cm0KvdJOaA_m{width:290px}.Ku8rvUQqBc4DdoqR1x6M{border-top:1px var(--border-neutral-default)solid;padding:4px}.fGpzIfIYT18gbD8qm0BT,.EQPGfabxIb4f9sOncA18{justify-content:center;align-items:center;padding:15px;display:flex}.x62ArXp0eAb7SIiYrMpr{height:100%;color:var(--content-primary-primary);text-overflow:ellipsis;padding:4px;font-size:13px;font-weight:400}.aes6WMStEl0tRbGDgEkB{background:var(--background-primary-inverted-primary);border:none;border-radius:6px;outline:none;padding:12px}.yYubozBruEtrqzrba6QM{border-bottom:1px solid var(--border-neutral-default)}.XFEk6tQlyo8ui_mqBhcK{background-color:var(--border-neutral-default);width:100%;height:1px;margin:4px 0}.N1Cl8ap5HFI4t2Uh81gR{color:var(--gray-60);justify-content:center;align-items:center;padding:15px;display:flex}.ynVDlwo93m04yOm8uPlt{padding:8.5px 12px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `dLJzyp73Cm0KvdJOaA_m`,
	"clear": `Ku8rvUQqBc4DdoqR1x6M`,
	"spinner": `fGpzIfIYT18gbD8qm0BT`,
	"epmtyList": `EQPGfabxIb4f9sOncA18`,
	"list": `x62ArXp0eAb7SIiYrMpr`,
	"search": `aes6WMStEl0tRbGDgEkB`,
	"searchWrap": `yYubozBruEtrqzrba6QM`,
	"divider": `XFEk6tQlyo8ui_mqBhcK`,
	"emptyList": `N1Cl8ap5HFI4t2Uh81gR`,
	"limitInfo": `ynVDlwo93m04yOm8uPlt`
};
export default ___CSS_LOADER_EXPORT___;
